import React, { Component, forwardRef } from 'react'
import './custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from "react-redux";
import { createStyles, makeStyles, withStyles, Theme } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Divider } from '@material-ui/core';
import UserApi from '../../api/Scoreboardapi';
import { Link } from "react-router-dom";
import SweetAlert from 'react-bootstrap-sweetalert';
import Modal from './Modal';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import NativeSelect from '@material-ui/core/NativeSelect';
import FormControl from '@material-ui/core/FormControl';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import InputBase from '@material-ui/core/InputBase';
import MaterialTable, { MTableAction } from "material-table";
import Footer from '../auth/Footer';
import * as routerHelpers from "../../router/RouterHelpers";
import moment from 'moment';
import { Helmet } from 'react-helmet'

import MenuLeftNav from './MenuLeftNav';
import { checkModulePermission } from "../../crud/auth.crud";
import * as auth from "../../store/ducks/auth.duck";
// import {handleLoginAs} from '../../utils/Utils.js';
import axios from "axios";

const CancelToken = axios.CancelToken;
let cancel;

library.add(fas)

// Styles
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} color="primary" ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} color="primary" ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }),
)(InputBase);

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      roleList: [],
      currentPage: 1,
      currentSortOrder: "ASC",
      sortBy: "name",
      isLoading: false,
      nameSort: {},
      lastLoginSort: {},
      textToSearch: '',
      rowsPerPage: 10,
      totalRecords: 10,
      rowsToSkip: 0,
      alert: '',
      hidepageination: false,
      showModal: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount = async () => {
    this.GetUserList()
    this.GetRoleList()
  }
  GetUserList = async () => {
    this.setState({ isLoading: true })
    if (cancel !== undefined) {
      cancel();
    }

    const options = {
      params: {
        "ModuleName": "Users",
        "LoggedInUserId": this.props.authUser.userId,
        "IsSuperAdmin": this.props.authUser.roleId == 1 ? 1 : 0,
        "Search": this.state.textToSearch,
        "OrderByFieldParam": this.state.sortBy,
        "SortOrderParam": this.state.currentSortOrder,
        "PageSize": this.state.rowsPerPage,
        "RowsToSkip": this.state.rowsToSkip
      },
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      })
    };
    await UserApi.get(`${process.env.REACT_APP_API_URL}api/user/getuserlist`, options)
      .then(res => {
        if (res.data.success == true) {
          this.setState({
            isLoading: false,
            userList: res.data.liUserResponse,
            hidepageination: true,
            totalRecords: res.data.listCount
          })
        }
        else {
          this.setState({
            isLoading: false,
            userList: [],
            totalRecords: 0
          })
        }
      })
      .catch(error => {
        this.setState({ isLoading: false, userList: [], totalRecords: 0 }); console.log(error.response)
        if (axios.isCancel(error)) {
          console.log("post Request canceled");
        }
      });
  }
  GetRoleList = async () => {
    const options = {
      params: {
        "Search": ""
      },
    };
    await UserApi.get(`${process.env.REACT_APP_API_URL}api/user/getroleandorganization`, options)
      .then(res => {
        this.setState({
          roleList: res.data.liRoleResponse
        })
      })
      .catch(error => { console.log(error.response) });
  }
  handleChange = (panel) => (event, newExpanded) => {
    this.setState({ [panel]: newExpanded ? panel : false });
  };
  handleChange = (userid, status) => {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        customClass='user-sweetalert'
        confirmBtnText={status && status == 1 ? 'Yes, Activate it!' : 'Yes,  Lock it!'}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        title="Are you sure?"
        onConfirm={() => this.updateUserStatus(userid, status)}
        onCancel={() => this.hideModel()}
        focusCancelBtn >
        {status && status == 1 ? 'You want to Activate this user ?' : 'You want to Lock this user ?'}
      </SweetAlert>
    )

    this.setState({
      alert: getAlert(),
      showModal: !this.state.showModal,
    })

  };
  hideModel = () => {
    this.setState({
      alert: '',
      showModal: false,
    })
  }
  updateUserStatus = (userid, status) => {
    let data = {
      Id: userid,
      Status: parseInt(status)
    }
    UserApi.post(`${process.env.REACT_APP_API_URL}api/user/lockunlockuser`, data)
      .then(result => {
        if (result.data.success == true) {
          this.displayAlert('Completed!', status && status == 1 ? 'User has been Activated.' : 'User has been Locked.', 'success')
        }
        else {
          this.displayAlert(result.data.message, "", 'error')
        }
        this.GetUserList()
      }).catch(error => {
        console.log(error.response)
        this.displayAlert("Something went wrong", "", 'error')
      });


  }
  changeSearch = async (event) => {
    if (!event.target.value || event.target.value == '' || (event.target.value && event.target.value.length >= 3)) {
      await this.setState({ textToSearch: event.target.value, rowsToSkip: 0 });
      await this.GetUserList()
    }
  }

  changePage = async (event) => {
    await this.setState({
      currentPage: event + 1,
      rowsToSkip: parseInt(event) > 0 ? parseInt(event) * parseInt(this.state.rowsPerPage) : 0
    });
    this.GetUserList()
  }
  changeOrderBy = async (orderedColumnId, orderDirection) => {
    if (orderedColumnId && orderDirection) {
      await this.setState({ currentPage: 1, rowsToSkip: 0, sortBy: orderedColumnId == 1 ? "name" : orderedColumnId == 3 ? 'last_login' : '', currentSortOrder: orderDirection });
      if (orderedColumnId == 1)
        this.setState({ nameSort: { defaultSort: orderDirection }, lastLoginSort: {} })
      if (orderedColumnId == 3)
        this.setState({ nameSort: {}, lastLoginSort: { defaultSort: orderDirection } })
      this.GetUserList()
    }
  }
  deleteOrRestoreUser = (userid, type) => {
    if (!userid)
      return false

    let data = {
      Id: userid,
      StatementType: type
    }
    UserApi.post(`${process.env.REACT_APP_API_URL}api/user/deleteandrestoreuser`, data)
      .then(result => {
        if (result.data.success == true) {
          this.displayAlert('Completed!', type == 'delete' ? "User has been deleted." : "User restored successfully!", 'success')
        }
        else {
          this.displayAlert(result.data.message, "", 'error')
        }
        this.GetUserList()
      })
      .catch(error => {
        this.displayAlert("Something went wrong", "", 'error')
      });

  }
  changeRowsPerPage = async (event) => {
    await this.setState({ rowsPerPage: event });
  }
  displayAlert = (title, message, type, userid, isDelete = true) => {
    let getAlert = '';
    if (type == 'success') {
      getAlert = () => (< SweetAlert
        success
        customClass='user-sweetalert'
        title={title}
        onConfirm={() => this.hideModel()} >
        {message}
      </SweetAlert>
      )
    }
    else if (type == 'deleteConfirmation') {
      getAlert = () => (<SweetAlert
        warning
        showCancel
        customClass='user-sweetalert'
        confirmBtnText={isDelete ? 'Yes, Delete it!' : "Yes, restore it!"}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"

        title={title}
        onConfirm={() => this.deleteOrRestoreUser(userid, isDelete ? 'delete' : 'restore')}
        onCancel={() => this.hideModel()}
        focusCancelBtn >
        {message}
      </SweetAlert>
      )
    }
    else {
      getAlert = () => (< SweetAlert
        error
        customClass='user-sweetalert'
        title={title}
        onConfirm={() => this.hideModel()} >
        {message}
      </SweetAlert>
      )
    }

    this.setState({
      alert: getAlert(),
      showModal: !this.state.showModal
    });
  }

  handleChangeUserRole = (userId, event) => {
    if (event.target.value && userId) {
      let RoleId = parseInt(event.target.value);

      let getAlert = () => (<SweetAlert
        warning
        showCancel
        customClass='user-sweetalert'
        confirmBtnText='Yes, change it!'
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"

        title='Are you sure?'
        onConfirm={() => this.changeUserRole(userId, RoleId)}
        onCancel={() => this.hideModel()}
        focusCancelBtn >
        You want to change the role for this user ?
      </SweetAlert>
      )

      this.setState({
        alert: getAlert(),
        showModal: !this.state.showModal
      });
    }
  };

  changeUserRole = (userId, RoleId) => {
    const formData = {
      "Id": userId,
      "RoleId": RoleId,
    };

    this.setState({
      showModal: !this.state.showModal
    });

    UserApi.post('user/updateuserrole', formData)
      .then((res) => {
        this.displayAlert(res.data.message, '', res.data.success == true ? 'success' : 'error')
        this.GetUserList()
      });
  }

  handleLoginAs = async (email, event) => {
    this.setState({ isLoading: true })
    const formData = {
      "Email": email,
    };

    await UserApi.post('user/loginAs', formData)
      .then((res) => {
        if (res.data.success) {
          if (res.data.liLoginAsModuleNameByRoleIdResponse && res.data.liLoginAsModuleNameByRoleIdResponse.length > 0) {
            this.props.logout()
            this.props.loginAs(res.data)
            localStorage.setItem("prevLoggedInEmail", this.props.authUser.email)
            localStorage.setItem("loadNewReferralParam", 1)
          } else {
            this.displayAlert("Role which assigned to this user has not any permission.", '', 'error')
          }
        }
        else {
          this.displayAlert(res.data.message, '', 'error')
        }
        this.setState({ isLoading: false })
      });
  }

  render() {
    const { showModal } = this.state;
    const data = this.props.dashboardData;

    let salerOrderItems = '';
    let deliveriesItems = '';
    if (data) {
      salerOrderItems = data.SalesOrderDetail;
      deliveriesItems = data.DeliveryList;
    }
    let isEditPermission = checkModulePermission("edit-user") || checkModulePermission("list-users-limited")
    return (
      <>
        {
          showModal ? (
            <Modal>
              {this.state.alert}
            </Modal>
          ) : null
        }
        <Helmet>
          <title>User List | Scorecard</title>
        </Helmet>
        <div className="main-content-body UserList">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3 left-side-bar">
                <MenuLeftNav isExpand={{ expand: "user", active: "user" }}></MenuLeftNav>
              </div>
              <div className="col-lg-9 mt-3 right-content-wrap  mb-5">

                <div className="order-and-adherence-detail">
                  <span className="manage-user-title">Manage User</span>

                  <div className="font-500 user-list-table">
                    <div className="form-inline p-3 jc-between users-list-form" style={{ height: '65px' }}>
                      <div className="userlist-heading-title">
                        <span className="ml-2 font-500 userlist-heading">User List</span>
                      </div>
                      <div className="user-add-btn">
                        <input type="text" placeholder="Enter 3 characters to search..." onChange={this.changeSearch} className="form-control mb-3" style={{ width: '230px' }} />

                        {checkModulePermission("add-user") === true &&
                          <Link className="btn btn-primary btn-elevate kt-cancel__btn-primary add-user-btn update-profile-btn" to="/user/create">
                            <FontAwesomeIcon icon={["fas", "plus"]} color="white" /> Add User
                          </Link>}
                      </div>
                    </div>
                    <Divider />
                    <div className="row p-3">
                      <div className="col-lg-12">
                        <div style={{ maxWidth: '100%' }}>
                          <MaterialTable
                            icons={tableIcons}
                            onChangePage={this.changePage}
                            onOrderChange={this.changeOrderBy}
                            onChangeRowsPerPage={this.changeRowsPerPage}
                            className="user-listing"
                            localization={{
                              body: {
                                emptyDataSourceMessage: this.state.isLoading == true
                                  ? "Loading..." : "No user to display"
                              }
                            }}
                            columns={[
                              {
                                title: 'Name', field: 'name', ...this.state.nameSort, render: rowData => {
                                  return <div>{rowData.name}<br /> {
                                    ((rowData.deleted_at == '' || rowData.deleted_at == null) && !localStorage.getItem('prevLoggedInEmail') && rowData.status == 1 && this.props.authUser.userId != rowData.id && this.props.authUser.roleId == 1) ?
                                      <a style={{ color: "#5867dd !important" }} href='#' onClick={(e) => this.handleLoginAs(rowData.email, e)}>Login as </a> : ''
                                  }
                                  </div>
                                }
                              },
                              {
                                title: 'Role', sorting: false, render: rowData => {
                                  return (checkModulePermission("list-users-limited") !== true && this.props.authUser.roleId == 1 && this.props.authUser.userId != rowData.id) ?
                                    <FormControl >
                                      <NativeSelect
                                        id="demo-customized-select-native"
                                        value={rowData.role_id}
                                        onChange={(e) => this.handleChangeUserRole(rowData.id, e)}
                                        input={<BootstrapInput />}
                                      >
                                        <option aria-label="None" value="">Please select</option>
                                        {this.state.roleList.map((role) => {
                                          return <option key={role.id} value={role.id}>{role.display_name}</option>
                                        })}
                                      </NativeSelect>
                                    </FormControl> : <label>
                                      {rowData.role_id ? this.state.roleList.map((role) => {
                                        return rowData.role_id == role.id ? role.display_name : ''
                                      }) : '-'}
                                    </label>
                                }
                              },
                              {
                                title: 'Last Login', field: 'last_login', ...this.state.lastLoginSort, render: rowData => {
                                  return rowData.last_login ? moment(rowData.last_login).format('MM/DD/YYYY') : '-';
                                }
                              },
                            ]}
                            data={this.state.userList}
                            page={this.state.currentPage - 1}
                            totalCount={this.state.totalRecords}
                            isLoading={this.state.isLoading}
                            options={{
                              padding: "dense",
                              showTitle: false,
                              toolbar: false,
                              actionsColumnIndex: -1,
                              search: false,
                              draggable: false,
                              pageSize: this.state.rowsPerPage,
                              cellStyle: {
                                padding: "10px",
                                color: '#575962',
                                fontSize: "13px",
                                fontWeight: "300"
                              },
                              headerStyle: {
                                backgroundColor: '#f4f3f8',
                                color: '#575962',
                                padding: "15px 10px",
                                fontSize: "13px",
                                fontWeight: "600"
                              },
                              emptyRowsWhenPaging: false,
                              paging: this.state.hidepageination,
                              pageSizeOptions: [5, 10, 20, 50, 100]
                            }}
                            components={{
                              Action: (props) => {
                                if (isEditPermission == true && props.action.tooltip == "Status" && (props.data.deleted_at == null || props.data.deleted_at == '')) {
                                  return <ToggleButtonGroup value={props.data.status} exclusive onChange={(event, status) => {
                                    this.handleChange(props.data.id, status)
                                  }}>
                                    <ToggleButton className="active" value="1" aria-label="Active" selected={props.data.status == 1}> Active </ToggleButton>
                                    <ToggleButton value="0" className="locked" aria-label="Locked" selected={props.data.status != 1}> Locked </ToggleButton>
                                  </ToggleButtonGroup>
                                }
                                // Edit resend
                                else if (isEditPermission === true && (props.action.tooltip == "Edit" || props.action.tooltip == "Resend") && (props.data.deleted_at == '' || props.data.deleted_at == null)) {
                                  return <MTableAction {...props} />;
                                }
                                // delete restore
                                else if (checkModulePermission("delete-user") === true && ((props.action.tooltip == "Delete" && (props.data.deleted_at == '' || props.data.deleted_at == null))
                                  || props.action.tooltip == "Restore" && props.data.deleted_at != null && props.data.deleted_at != '')) {
                                  return <MTableAction {...props} />;
                                }
                                else {
                                  return null
                                }
                              }
                            }}
                            actions={[
                              {
                                icon: () => { return <FontAwesomeIcon icon={["fas", "edit"]} size='lg' /> },
                                tooltip: 'Edit',
                                hidden: checkModulePermission('list-users-limited') === true && this.props.authUser.roleId !== 1,
                                onClick: (event, rowData) => {

                                  this.props.history.push('/user/edit/' + rowData.id);
                                  
                                  // const userData = JSON.parse(localStorage.getItem("persist:userData"));
                                  // let authToken = '';

                                  // if (userData && userData.authToken) {
                                  //   authToken = userData.authToken.replace(/"/g,'');
                                  // }
                                  // let userProfile = ''
                                  // if (userData && userData.user) {
                                  //   userProfile = JSON.parse(userData.user)
                                  // }

                                  // if (rowData.id == userProfile.userId) {
                                  //   this.props.history.push("/users/update-profile");

                                  // }
                                  // else {
                                  //   this.props.history.push('/user/edit/' + rowData.id);
                                  // }

                                }
                              },
                              {
                                icon: () => { return <FontAwesomeIcon icon={["fas", "envelope"]} size='lg' /> },
                                tooltip: 'Resend',
                                hidden: checkModulePermission('list-users-limited') === true && this.props.authUser.roleId !== 1,
                                onClick: (event, rowData) => {
                                  let data = {
                                    Id: rowData.id,
                                    Email: rowData.email,
                                    Name: rowData.name
                                  }
                                  this.setState({ isLoading: true })
                                  UserApi.post(`${process.env.REACT_APP_API_URL}api/user/resendemail`, data)
                                    .then(result => {
                                      if (result.data.success == true) {
                                        this.displayAlert('Completed!', 'Resend email sent successfully!', 'success')
                                      }
                                      else {
                                        this.displayAlert(result.data.message, "", 'error')
                                      }
                                      this.GetUserList()
                                      this.setState({ isLoading: false })
                                    })
                                    .catch(error => {
                                      this.setState({ isLoading: false })
                                      console.log(error.response)
                                      this.displayAlert("Something went wrong", "", 'error')
                                    });
                                }
                              },
                              {
                                icon: () => { return <FontAwesomeIcon icon={["fas", "trash"]} size='lg' /> },
                                tooltip: 'Delete',
                                hidden: checkModulePermission('list-users-limited') === true && this.props.authUser.roleId !== 1,
                                onClick: (event, rowData) => {
                                  this.displayAlert("Are you sure?", "You want to delete this user ?", 'deleteConfirmation', rowData.id, true)
                                }
                              },
                              {
                                icon: () => { return <FontAwesomeIcon icon={["fas", "trash"]} size='lg' /> },
                                tooltip: 'Status',
                                hidden: checkModulePermission('list-users-limited') === true && this.props.authUser.roleId !== 1,
                                onClick: (event, rowData) => { }
                              },
                              {
                                icon: () => { return <FontAwesomeIcon icon={["fas", "undo-alt"]} size='lg' /> },
                                tooltip: 'Restore',
                                onClick: (event, rowData) => {
                                  this.displayAlert("Are you sure?", "You want to restore this user ?", 'deleteConfirmation', rowData.id, false)
                                }
                              }
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
function mapStateToProps(state) {
  var parsedUserData = state.auth.user;
  var AuthToken = state.auth.authToken;
  let PtKey = '';
  // for (var parsedJson in parsedUserData) {
  //   PtKey = parsedUserData[parsedJson].PtKey;
  // }
  return {
    authUser: parsedUserData,
    dashboardData: state.auth.dashboardData,
    loading: state.auth.loading,
    PtKey: PtKey,
    AuthToken: AuthToken
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, auth.actions)(UserList);
